import React, { useEffect } from 'react';
import PropTypes from 'prop-types';

import './FontSizeField.less';

export default function FontSizeField({ input: { value, onChange }, maxSize, minSize }) {
  // normalize font size if minSize or maxSize changes
  useEffect(() => {
    const updatedValue = Math.min(Math.max(value, minSize), maxSize);

    if (updatedValue !== value && onChange instanceof Function) {
      onChange(updatedValue);
    }
  }, [minSize, maxSize]);

  return (
    <div className="font-size-field">
      {maxSize && value && value < maxSize ? (
        <div className="font-size-option" onClick={() => onChange(value + 1)}>
          <i className="zolaicon zolaicon-plus" />
        </div>
      ) : (
        <div className="font-size-option font-size-option--disabled">
          <i className="zolaicon zolaicon-plus" />
        </div>
      )}
      <div className="font-size-option font-size-option--active">{value}</div>
      {value && value > minSize ? (
        <div className="font-size-option" onClick={() => onChange(value - 1)}>
          <span className="fake-minus-icon" />
        </div>
      ) : (
        <div className="font-size-option font-size-option--disabled">
          <span className="fake-minus-icon" />
        </div>
      )}
    </div>
  );
}

FontSizeField.propTypes = {
  input: PropTypes.shape({}),
  maxSize: PropTypes.number,
  minSize: PropTypes.number,
};



// WEBPACK FOOTER //
// ./src/cards/components/Customization/ElementStyleEditor/FontSizeField/FontSizeField.jsx